import { AnyAction } from "redux";
import { PptType } from "../../tournaments/types";
import { PptInterface } from "../types";
import { defaultPptsFilters } from "../constants";

export const requested = (
  state: PptInterface,
  key: PptType,
  paginated?: boolean
): PptInterface => ({
  ...state,
  requestStates: {
    ...state.requestStates,
    [key]: {
      ...state.requestStates[key],
      data: { failed: false, requesting: true, success: false },
      paginated: paginated
        ? { failed: false, requesting: true, success: false }
        : state.requestStates[key].paginated,
    },
  },
});

export const success = (
  state: PptInterface,
  action: AnyAction,
  key: PptType,
  paginated?: boolean
): PptInterface => ({
  ...state,
  ppt: {
    ...state.ppt,
    [key]: {
      ...state.ppt[key],
      data: paginated
        ? [
            ...(action.payload.ppt.page === 1 ? [] : state.ppt[key].data || []),
            ...action.payload.ppt.data,
          ]
        : action.payload.ppt.data,
      page: paginated
        ? action.payload.ppt.data.length === 0
          ? action.payload.ppt.page - 1
          : action.payload.ppt.page
        : 1,
      isLastPage:
        action.payload.ppt.data.length === 0
          ? true
          : state.ppt[key].isLastPage,
      game: action.payload.ppt.game,
    },
  },
  requestStates: {
    ...state.requestStates,
    [key]: {
      ...state.requestStates[key],
      data: { failed: false, requesting: false, success: true },
      paginated: paginated
        ? { failed: false, requesting: false, success: true }
        : state.requestStates[key].paginated,
    },
  },
});

export const failed = (
  state: PptInterface,
  action: AnyAction,
  key: PptType,
  paginated?: boolean
): PptInterface => ({
  ...state,
  requestStates: {
    ...state.requestStates,
    [key]: {
      ...state.requestStates[key],
      data: { failed: action.error, requesting: false, success: false },
      paginated: paginated
        ? { failed: action.error, requesting: false, success: false }
        : state.requestStates[key].paginated,
    },
  },
});

export const clear = (
  state: PptInterface,
  key: PptType,
  paginated?: boolean
): PptInterface => ({
  ...state,
  ppt: {
    ...state.ppt,
    [key]: {
      game: null,
      data: [],
      filter: { ...defaultPptsFilters },
    },
  },
  requestStates: {
    ...state.requestStates,
    [key]: {
      ...state.requestStates[key],
      data: { failed: false, requesting: false, success: false },
      paginated: paginated
        ? { failed: false, requesting: false, success: false }
        : state.requestStates[key].paginated,
    },
  },
});